// Order matters: primitives, then the theme's semantic tokens, then base styles that use them.
import '@fontsource-variable/inter'
import './tokens.css'
import './themes/gallery.css'
import './base.css'

/** Themes shipped in `themes/`. Add a name here when you add a theme file. */
export type ThemeName = 'gallery'

export function applyTheme(name: ThemeName): void {
  document.documentElement.dataset.theme = name
}
